

import { getCompanyStepSchemesData, getVitaranStepSchemesData } from "../slice/coinSlice";
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch } from "react-redux";


const useGetStepSchemes = (schemeSponsor) => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();
  
  const getStepSchemes = async () => {
    try {
      const param = { scheme_sponsor: schemeSponsor }; 
      // console.log("Fetching step schemes for sponsor:", param);
      const response = await Axios.post("/get_step_schemes", param);
      const data = response.data;
      // console.log(data, "data");

      // if (schemeSponsor === 'company') {
      //   dispatch(getCompanyStepSchemesData(data?.schemes_list));
      // } else if (schemeSponsor === 'vitaran') {
      //   dispatch(getVitaranStepSchemesData(data?.schemes_list));
      // }
      return data;  
    } catch (error) {
      console.log("Error fetching getStepSchemes data:", error);
    }
  };
  return getStepSchemes;
};

export default useGetStepSchemes;

